import React from 'react'
// import PropTypes from 'prop-types'
import Spinner from 'react-bootstrap/Spinner'

const Loader = props => {
	return (
		<Spinner
			animation="border"
			role="status"
			style={{ display: 'block', height: 100, margin: 'auto', width: 100 }}
		>
			<span className="sr-only">Loading...</span>
		</Spinner>
	)
}

Loader.propTypes = {
	//
}

export default Loader
